export interface PanelConfig {
    id?: string;
    title?: string;    /** Header title */
    subTitle?: string;
    isVideo?: boolean;
    videoUrl?: any;
    size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl';  /** Panel size */
    position?: 'right' | 'left';   /** Panel position */
    hasOverlay?: boolean;
    projectedContent?: boolean; /** Flag to determine if projected content exists */
    hideCloseIcon?: boolean; /** Hide the header close (X) icon */
    hideScrollButtons?: boolean;
}

export const DEFAULT_PANEL_CONFIG: PanelConfig = {
    id: '',
    title: '',
    subTitle: '',
    isVideo: false,
    videoUrl: '',
    size: 'md',
    position: 'right',
    hasOverlay: true,
    projectedContent: false,
    hideScrollButtons: true,
};